let currentTimeout: number | null = null;
let isWatcherActive = false;

export function startTokenExpirationWatcher(): void {
  // Se já existe um watcher ativo, não cria outro
  if (isWatcherActive && currentTimeout) {
    return;
  }

  // Limpa o timeout anterior se existir
  if (currentTimeout) {
    clearTimeout(currentTimeout);
    currentTimeout = null;
  }

  isWatcherActive = true;

  const refreshTime = 1000 * 60 * 45; // 45 minutos

  currentTimeout = window.setTimeout(() => {
    isWatcherActive = false; // Libera para permitir reagendamento
    const event = new CustomEvent<number>("token-expiration-warning", {
      detail: refreshTime,
    });
    window.dispatchEvent(event);
  }, refreshTime);
}

export function clearTokenWatcher(): void {
  if (currentTimeout) {
    clearTimeout(currentTimeout);
    currentTimeout = null;
    isWatcherActive = false;
    console.log("[TokenWatcher] Watcher cancelado");
  }
}
